import { DefaultRootState } from 'react-redux';

import { Creds } from 'src/models/applicant/resume/blocks/creds/types';

export const selectResumeCreds = ({ applicantResume }: DefaultRootState): Creds => applicantResume.creds;
